// extracted by mini-css-extract-plugin
export default {"root":"ScenariosPage_root__WXiT8"};